let selectedOptions = {};
let lastProductItem = null;

function updateCollectionSwitcherImage(element, newImageUrl) {
	const productItem = element.closest(".grid-product");
	if (!productItem) return;

	if (productItem !== lastProductItem) {
		const swatches = lastProductItem ? lastProductItem.querySelectorAll(".color-swatch--small.active") : [];
		selectedOptions = {};
		lastProductItem = productItem;
		swatches.forEach(swatch => {
			swatch.classList.remove('active');
		});
	}



	const productVariants = JSON.parse(productItem.getAttribute('data-variants'));

	const optionIndex = element.getAttribute('data-option-index');
	const optionValue = element.getAttribute('data-option-value');


	const swatches = productItem.querySelectorAll(`.color-swatch[data-option-index="${optionIndex}"]`);

	swatches.forEach(swatch => {
		swatch.classList.remove('active');
	});

	element.classList.add('active');


	selectedOptions[optionIndex] = optionValue;

	const matchingVariant = productVariants.find(variant => {
		return Object.keys(selectedOptions).every(index => {
			return variant.options[index] === selectedOptions[index];
		});
	});

	if (matchingVariant) {
		newImageUrl = matchingVariant.featured_image.src;
		const productLink = productItem.querySelector(".grid-product__link");
		if (productLink) {
			let baseUrl = productLink.href.split('?')[0];
			productLink.href = `${baseUrl}?variant=${matchingVariant.id}`;
		}
	}

	const imageElements = productItem.querySelectorAll("img");
	imageElements.forEach((img) => {
		img.src = newImageUrl;
		const newBaseURL = newImageUrl.split("?")[0];
		const newSrcSet = img.srcset
			.split(", ")
			.map((entry) => {
				const [url, descriptor] = entry.split(" ");
				const paramsIndex = url.indexOf("&");
				const params = paramsIndex > -1 ? url.substring(paramsIndex) : "";
				const newUrl = `${newBaseURL}?v=${Date.now()}${params}`;
				return `${newUrl} ${descriptor}`;
			})
			.join(", ");
		img.srcset = newSrcSet;
	});
}

document.addEventListener("DOMContentLoaded", function () {
	const productImagesContainer = document.querySelector('[data-product-images]');
	const hasVariantImages = productImagesContainer.getAttribute('data-has-variant-images') === 'true';
	if (hasVariantImages) {
		initializeEventListeners();
	}
});

function refreshArrowVisibility() {
	const visibleThumbs = Array.from(
		document.querySelectorAll(".product__thumb-item")
	).filter((thumb) => thumb.style.display !== "none");

	const activeIndex = visibleThumbs.findIndex((thumb) =>
		thumb.querySelector("a").classList.contains("is-active")
	);

	const arrowPrev = document.querySelector(".product__thumb-arrow--prev");
	const arrowNext = document.querySelector(".product__thumb-arrow--next");

	if (arrowPrev) arrowPrev.classList.remove("hide");
	if (arrowNext) arrowNext.classList.remove("hide");

	const showArrows = shouldShowArrows();
	if (!showArrows) {
		if (arrowPrev) arrowPrev.classList.add("hide");
		if (arrowNext) arrowNext.classList.add("hide");
		return;
	}

	if (arrowPrev) arrowPrev.classList.toggle("hide", activeIndex <= 0);
	if (arrowNext)
		arrowNext.classList.toggle("hide", activeIndex >= visibleThumbs.length - 1);
}



function updateThumbnailVisibility(selectedVariantId) {
	document.querySelectorAll(".product__thumb-item").forEach((thumb) => {
		const variants = thumb.getAttribute("data-variants").split(",");
		const isAttachedToVariant = variants.includes(String(selectedVariantId));
		thumb.style.display = isAttachedToVariant ? "block" : "none";

		if (isAttachedToVariant) {
			thumb.addEventListener("click", function () {
				refreshArrowVisibility();
			});
		}
	});
}

function shouldShowArrows() {
	const visibleThumbs = Array.from(
		document.querySelectorAll(".product__thumb-item")
	).filter((thumb) => thumb.style.display !== "none");

	if (visibleThumbs.length <= 1) return false;

	const lastVisibleThumb = visibleThumbs[visibleThumbs.length - 1];
	const lastThumbRect = lastVisibleThumb.getBoundingClientRect();
	const arrowNext = document.querySelector(".product__thumb-arrow--next");
	const arrowNextRect = arrowNext.getBoundingClientRect();
	return lastThumbRect.bottom >= arrowNextRect.top;
}


function initializeEventListeners() {
	document.querySelectorAll(".variant-input input, .variant-input-wrap select").forEach((input) => {
		input.addEventListener("change", function () {
			const selectedVariantId = document.querySelector('[name="id"]').value;
			updateThumbnailVisibility(selectedVariantId);
			refreshArrowVisibility();
		});

	});

	const initialVariantId = document.querySelector('[name="id"]').value;
	updateThumbnailVisibility(initialVariantId);
	refreshArrowVisibility();

	configureArrowNavigation();
}

function arrowClickHandler(arrow) {
	const isNext = arrow.classList.contains("product__thumb-arrow--next");
	const visibleThumbs = Array.from(
		document.querySelectorAll(".product__thumb-item")
	).filter((thumb) => thumb.style.display !== "none");

	const currentIndex = visibleThumbs.findIndex((thumb) =>
		thumb.querySelector("a").classList.contains("is-active")
	);

	let targetIndex = isNext ? currentIndex + 1 : currentIndex - 1;

	if (targetIndex >= visibleThumbs.length) {
		targetIndex = visibleThumbs.length - 1;
	} else if (targetIndex < 0) {
		targetIndex = 0;
	}

	if (visibleThumbs[currentIndex]) {
		visibleThumbs[currentIndex]
			.querySelector("a")
			.classList.remove("is-active");
	}

	if (visibleThumbs[targetIndex]) {
		visibleThumbs[targetIndex].querySelector("a").classList.add("is-active");
	}

	const mainSlider = Flickity.data(
		document.querySelector(".product-slideshow")
	);
	mainSlider.select(
		visibleThumbs[targetIndex].getAttribute("data-index"),
		false,
		true
	);
	refreshArrowVisibility();
}

function configureArrowNavigation() {
	document.querySelectorAll(".product__thumb-arrow").forEach((arrow) => {
		let newArrow = arrow.cloneNode(true);
		arrow.parentNode.replaceChild(newArrow, arrow);

		newArrow.addEventListener("click", (e) => {
			arrowClickHandler(newArrow);
		});
	});
}

